<template>
  <!-- 能耗监测大屏 -->
  <div class="app-container">
    <div class="title-container">
      <span class="runDays"> 能源看板</span>
      {{ operationData.platformName }}
      <span class="time">{{ timeStr }}</span>
    </div>
    <div class="content-container clearfix">
      <div class="left-container">
        <div class="top-container clearfix">
          <div style="margin-bottom: 10px;">
            <span class="name-box">能耗统计</span>
          </div>
          <div
            style="display: flex;justify-content:space-around; margin: 0 -5px;height: 240px;"
          >
            <div class="year-box">
              <div class="item-box">
                <div
                  class="device-icon"
                  style="background-image: url('/static/image/nyjk/dnljznh.png');"
                ></div>
                <div class="item-data-box">
                  <div>当年累计总能耗</div>
                  <div style="margin-top: 10px;">
                    <span class="num-box">
                      {{ energyData.sumStandardCoalYear }}
                    </span>
                    <span style="font-size: 14px;">kgce</span>
                  </div>
                </div>
              </div>
              <div class="item-box">
                <div
                  class="device-icon"
                  style="background-image: url('/static/image/nyjk/yd.png');"
                ></div>
                <div class="item-data-box">
                  <div>当年累计用电</div>
                  <div style="margin-top: 10px;">
                    <span class="num-box">
                      {{ energyData.sumElectricityIncreasingFlowYear }}
                    </span>
                    <span style="font-size: 14px;">kwh</span>
                  </div>
                </div>
              </div>
              <div class="item-box">
                <div
                  class="device-icon"
                  style="background-image: url('/static/image/nyjk/ys.png');"
                ></div>
                <div class="item-data-box">
                  <div>当年累计用水</div>
                  <div style="margin-top: 10px;">
                    <span class="num-box">
                      {{ energyData.sumWaterIncreasingFlowYear }}
                    </span>
                    <span style="font-size: 14px;">t</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="mouth-box">
              <div class="item-box">
                <div
                  class="device-icon"
                  style="background-image: url('/static/image/nyjk/dyznh.png');"
                ></div>
                <div class="item-data-box">
                  <div>当月总能耗</div>
                  <div style="margin-top: 10px;">
                    <span class="num-box">
                      {{ energyData.sumStandardCoalMonth }}
                    </span>
                    <span style="font-size: 14px;">kgce</span>
                  </div>
                </div>
              </div>
              <div class="item-box">
                <div
                  class="device-icon"
                  style="background-image: url('/static/image/nyjk/yd.png');"
                ></div>
                <div class="item-data-box">
                  <div>当月用电</div>
                  <div style="margin-top: 10px;">
                    <span class="num-box">
                      {{ energyData.monthElectricityIncreasingFlowMonth }}
                    </span>
                    <span style="font-size: 14px;">kwh</span>
                  </div>
                </div>
              </div>
              <div class="item-box">
                <div
                  class="device-icon"
                  style="background-image: url('/static/image/nyjk/ys.png');"
                ></div>
                <div class="item-data-box">
                  <div>当月用水</div>
                  <div style="margin-top: 10px;">
                    <span class="num-box">
                      {{ energyData.monthWaterIncreasingFlowMonth }}
                    </span>
                    <span style="font-size: 14px;">t</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="day-box">
              <div class="item-box">
                <div
                  class="device-icon"
                  style="background-image: url('/static/image/nyjk/drznh.png');"
                ></div>
                <div class="item-data-box">
                  <div>当日总能耗</div>
                  <div style="margin-top: 10px;">
                    <span class="num-box">
                      {{ energyData.sumStandardCoalDay }}
                    </span>
                    <span style="font-size: 14px;">kgce</span>
                  </div>
                </div>
              </div>
              <div class="item-box">
                <div
                  class="device-icon"
                  style="background-image: url('/static/image/nyjk/yd.png');"
                ></div>
                <div class="item-data-box">
                  <div>当日用电</div>
                  <div style="margin-top: 10px;">
                    <span class="num-box">
                      {{ energyData.sumElectricityStandardCoalDay }}
                    </span>
                    <span style="font-size: 14px;">kwh</span>
                  </div>
                </div>
              </div>
              <div class="item-box">
                <div
                  class="device-icon"
                  style="background-image: url('/static/image/nyjk/ys.png');"
                ></div>
                <div class="item-data-box">
                  <div>当日用水</div>
                  <div style="margin-top: 10px;">
                    <span class="num-box">
                      {{ energyData.sumElectricityStandardCoalDay }}
                    </span>
                    <span style="font-size: 14px;">t</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="previous-box">
              <div class="item-box">
                <div
                  class="device-icon"
                  style="background-image: url('/static/image/nyjk/znhyhb.png');"
                ></div>
                <div class="item-data-box">
                  <div>总能耗月环比</div>
                  <div style="margin-top: 10px;">
                    <span class="num-box">
                      {{ energyData.MonthSumBasis }}%
                    </span>
                  </div>
                </div>
                <div
                  style="position: absolute;right: 10px;bottom: 20px;color: #67C23A;"
                  v-if="
                    energyData.MonthSumBasis && energyData.MonthSumBasis > 0
                  "
                >
                  <i class="el-icon-top"></i>
                </div>
                <div
                  style="position: absolute;right: 10px;bottom: 20px;color: #F56C6C;"
                  v-else
                >
                  <i class="el-icon-bottom"></i>
                </div>
              </div>
              <div class="item-box">
                <div
                  class="device-icon"
                  style="background-image: url('/static/image/nyjk/yd.png');"
                ></div>
                <div class="item-data-box">
                  <div>用电月环比</div>
                  <div style="margin-top: 10px;">
                    <span class="num-box">
                      {{ energyData.MonthElectricityBasis }}%
                    </span>
                  </div>
                </div>
                <div
                  style="position: absolute;right: 10px;bottom: 20px;color: #67C23A;"
                  v-if="
                    energyData.MonthElectricityBasis &&
                      energyData.MonthElectricityBasis > 0
                  "
                >
                  <i class="el-icon-top"></i>
                </div>
                <div
                  style="position: absolute;right: 10px;bottom: 20px;color: #F56C6C;"
                  v-else
                >
                  <i class="el-icon-bottom"></i>
                </div>
              </div>
              <div class="item-box">
                <div
                  class="device-icon"
                  style="background-image: url('/static/image/nyjk/ys.png');"
                ></div>
                <div class="item-data-box">
                  <div>用水月环比</div>
                  <div style="margin-top: 10px;">
                    <span class="num-box">
                      {{ energyData.MonthWaterBasis }}%
                    </span>
                  </div>
                </div>
                <div
                  style="position: absolute;right: 10px;bottom: 20px;color: #67C23A;"
                  v-if="
                    energyData.MonthWaterBasis && energyData.MonthWaterBasis > 0
                  "
                >
                  <i class="el-icon-top"></i>
                </div>
                <div
                  style="position: absolute;right: 10px;bottom: 20px;color: #F56C6C;"
                  v-else
                >
                  <i class="el-icon-bottom"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-container-nhqs clearfix">
          <div class="name-box">能耗趋势</div>
          <div style="color: #5492ED;position: absolute;left: 20px;top: 30px;">
            (kgce)
          </div>
          <div
            class="echart-container"
            v-if="showChart1"
            id="echart-bar1"
          ></div>
        </div>
      </div>
      <div class="right-container">
        <div class="top-container clearfix">
          <div class="ynzb-box">
            <div style="margin-bottom: 10px;">
              <span class="name-box">用能占比</span>
            </div>
            <div class="pie1-box">
              <div style="height: 100%;" id="echart-pie"></div>
            </div>
          </div>
          <div class="yxqk-box">
            <div style="margin-bottom: 10px;">
              <span class="name-box">运行情况</span>
            </div>
            <div class="qkdata-box">
              <div class="qkdata-box-item">
                <div class="qkdata-box-item-name">
                  <div
                    style="width: 32px;height: 32px;margin-right: 20px;background-image: url('/static/image/nyjk/yxts.png');background-repeat: no-repeat;
          background-size: cover;"
                  ></div>
                  <div>运行天数</div>
                </div>
                <div class="qkdata-box-item-num">
                  {{ operationData.runDays }}
                  <span style="font-size: 12px;color: #fff;">天</span>
                </div>
              </div>
              <div class="qkdata-box-item">
                <div class="qkdata-box-item-name">
                  <div
                    style="width: 32px;height: 32px;margin-right: 20px;background-image: url('/static/image/nyjk/ljznh.png');background-repeat: no-repeat;
          background-size: cover;"
                  ></div>
                  <div>累计总能耗</div>
                </div>
                <div class="qkdata-box-item-num">
                  {{ operationData.sumStandardCoal }}
                  <span style="font-size: 12px;color: #fff;">kgce</span>
                </div>
              </div>
              <div class="qkdata-box-item">
                <div class="qkdata-box-item-name">
                  <div
                    style="width: 32px;height: 32px;margin-right: 20px;background-image: url('/static/image/nyjk/ynyccs.png');background-repeat: no-repeat;
          background-size: cover;"
                  ></div>
                  <div>用能异常次数</div>
                </div>
                <div class="qkdata-box-item-num">
                  {{ operationData.alarmCount }}
                  <span style="font-size: 12px;color: #fff;">次</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-container-ynpm clearfix">
          <div class="name-box">用能排名</div>
          <div style="color: #5492ED;position: absolute;left: 20px;top: 30px;">
            (kgce)
          </div>
          <div class="echart-container" id="echart-panel"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import * as utils from "@/utils";
import { postAction, getAction } from "@/api";

export default {
  components: {},
  data() {
    return {
      userInfo: JSON.parse(window.localStorage.userInfo),
      timeStr: utils.getTotime() + `(星期${utils.getWeek()})`,
      monitorData: {},
      energyData: {},
      showChart1: false,
      operationData: {},
      echartPanel: null,
      echartZhu: null
    };
  },
  created() {
    this.getEnergyData(); //获取能耗数据
    this.getEnergyTrend(); //能耗趋势
    this.getEnergyProportionConsumption(); //用能占比
    this.getEnergyRank(); //用能排名
  },
  mounted() {
    window.addEventListener("resize", () => {
      if (!utils.isNull(this.echartPanel)) {
        this.echartPanel.resize();
      }
      if (!utils.isNull(this.echartZhu)) {
        this.echartZhu.resize();
      }
    });
  },
  methods: {
    getEnergyData() {
      postAction("/iot/energy-data/queryEnergyConsumptionStatistics", {
        projectId: this.userInfo.projectId
      }).then(res => {
        let res0 = res.data;
        if (res0.code == 200) {
          this.energyData = res0.data;
        } else {
          this.$message.error(res0.msg);
        }
      });
    },
    getEnergyTrend() {
      postAction("/iot/energy-data/queryEnergyTrend", {
        projectId: this.userInfo.projectId
      }).then(res1 => {
        let res = res1.data;
        if (res.code == 200) {
          if (!utils.isNull(res.data) && res.data.list.length > 0) {
            this.showChart1 = true;
            // this.list = res.data;
            console.log(res, "res2222");
            setTimeout(() => {
              this.setEchartBar1(res.data.list, res.data.times);
            }, 100);
          }
        } else {
          this.$message.error(res0.msg);
        }
      });
    },
    // 创建堆叠面积图
    setEchartBar1(arr, dataMap) {
      if (this.showChart1 == false) {
        return;
      }

      // 拼接数据
      let data = [];
      let listData = [];
      for (let index = 0; index < dataMap.length; index++) {
        let obj = {
          yearMonthDate: dataMap[index],
          count: 0,
          type: ""
        };
        listData.push(obj);
      }

      // 固定颜色数组
      const colors = ["#457CC7", "#A15630", "#2FB0A4", "#893C8C"];

      for (let i = 0; i < arr.length; i++) {
        let itemLine = arr[i];
        let lineObj = {
          name: itemLine.name,
          type: "line",
          stack: "总量",
          areaStyle: {
            color: colors[i % colors.length]
          },
          lineStyle: {
            color: colors[i % colors.length]
          },
          data: []
        };

        let map = itemLine.list;
        for (let key = 0; key < map.length; key++) {
          for (let k = 0; k < listData.length; k++) {
            if (map[key].time == listData[k].yearMonthDate) {
              lineObj.data.push(map[key].value);
            }
          }
        }

        data.push(lineObj);
      }

      console.log(data, "data--------------");

      // 绘制图标
      var myChart = echarts.init(document.getElementById("echart-bar1"));
      var option = {
        title: {
          text: ""
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        legend: {
          top: 10,
          left: "center",
          right: "auto",
          textStyle: {
            color: function(params) {
              return colors[params.dataIndex % colors.length]; // 设置图例文字颜色
            }
          }
        },
        color: colors, // 设置全局颜色用于图例和系列自动匹配
        grid: {
          left: "2%",
          right: "2%",
          bottom: "2%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: dataMap
        },
        yAxis: {
          type: "value"
        },
        series: data
      };

      myChart.clear();
      myChart.setOption(option);

      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    getEnergyProportionConsumption() {
      postAction("/iot/energy-data/queryEnergyProportionConsumption", {
        projectId: this.userInfo.projectId
      }).then(res => {
        let res0 = res.data;
        if (res0.code == 200) {
          this.createChartYongNeng(res0.data);
          this.operationData = res0.data;
        } else {
          this.$message.error(res0.msg);
        }
      });
    },
    createChartYongNeng(data) {
      if (!utils.isNull(this.echartPanel)) {
        this.echartPanel.clear();
      }
      let seriesData = [
        { value: data.waterSumStandardCoalBasis, name: "用水" },
        { value: data.electricitySumStandardCoalBasis, name: "用电" }
      ];
      this.echartPanel = echarts.init(document.getElementById("echart-pie"));
      console.log(this.echartPanel, "echartPanel");
      let option = {
        color: ["#E47931", "#B742A5", "#0AFBBD"],

        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} ({d}%)"
        },

        title: {
          textAlign: "center" // 主、副标题水平居中显示
        },
        grid: {
          top: "10%"
        },
        legend: {
          top: "5%",
          left: "center",
          textStyle: {
            color: "#fff"
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            center: ["50%", "55%"],
            radius: ["80%", "50%"],
            avoidLabelOverlap: false,
            data: seriesData,
            labelLine: {
              show: false
            },
            label: {
              show: false
            }
          }
        ]
      };
      this.echartPanel.setOption(option);
    },
    getEnergyRank() {
      postAction("/iot/energy-data/queryEnergyRank", {
        projectId: this.userInfo.projectId
      }).then(res => {
        let res0 = res.data;
        if (res0.code == 200) {
          console.log(res0, "res0000");
          this.$nextTick(() => {
            this.createChart(res0.list);
          });
        } else {
          this.$message.error(res0.msg);
        }
      });
    },
    // 创建图表
    createChart(data) {
      console.log(data, "data");

      if (data.length == 0) {
        if (!utils.isNull(this.echartZhu)) {
          this.echartZhu.clear();
        }
        return;
      }
      let legendData = [];
      let xAxisData = [];
      let seriesData = [];
      for (let i of data) {
        legendData.push(i.equipRoomName);
        xAxisData.push(i.equipRoomName);
        seriesData.push(i.monthStandardCoal);
      }
      // 基于准备好的dom，初始化echarts实例
      this.echartZhu = echarts.init(document.getElementById("echart-panel"));
      // 指定图表的配置项和数据
      let option = {
        color: function(params) {
          let colorList = [
            "#249CF9",
            "#EB6F49",
            "#FDB628",
            "#00E4EC",
            "#69FD28",
            "#C490BF",
            "#FFF100",
            "#486A00",
            "#F6B37F",
            "#7ECEF4",
            "#22AC38",
            "#7E6B5A"
          ];
          return colorList[params.dataIndex % colorList.length];
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        dataZoom: [
          {
            type: "inside"
          }
        ],
        grid: {
          left: "0",
          right: "2%",
          top: "10%",
          bottom: "2%",
          containLabel: true
        },
        legend: {
          data: legendData
        },
        xAxis: {
          type: "category",
          data: xAxisData,
          axisPointer: {
            type: "shadow"
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#5492ED",
              fontSize: "12"
            }
          },
          axisLine: {
            // 轴线
            lineStyle: {
              color: "#5492ED"
            }
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#5492ED",
              fontSize: "12"
            }
          },
          axisLine: {
            // 轴线
            lineStyle: {
              color: "#5492ED"
            }
          },
          splitLine: {
            // 轴上的分割线
            show: true,
            lineStyle: {
              // 设置分割线单独的样式
              color: "#5492ED"
            }
          }
        },
        series: [
          {
            type: "bar",
            barWidth: "30",
            data: seriesData,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "top"
                }
              }
            }
          }
        ]
      };

      this.echartZhu.setOption(option);
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.app-container {
  background: url("/static/image/equip/bg.png") no-repeat center;
  background-size: cover;
  padding: 0 20px;
  .title-container {
    position: relative;
    height: 96px;
    line-height: 88px;
    text-align: center;
    color: #ffffff;
    font-size: 36px;
    font-weight: bold;
    background: url("/static/image/equip/top-bj@2x.png") no-repeat center;
    background-size: 100% 100%;
    .runDays {
      position: absolute;
      left: 0;
      width: 492px;
      margin-bottom: 0;
      font-size: 20px;
      padding-top: 6px;
      text-align: center;
    }
    .time {
      position: absolute;
      width: 30%;
      right: 0;
      font-size: 20px;
      padding-top: 6px;
    }
  }
  .name-box {
    color: #ffffff;
    font-size: 16px;
  }
  .num-box {
    color: #03a7c0;
    font-size: 16px;
    font-weight: bolder;
  }
  .device-icon {
    width: 38px;
    height: 38px;
    background-position: center;
    background-size: cover;
  }
  .content-container {
    height: calc(100% - 96px);
    overflow: hidden;
    .left-container {
      float: left;
      width: calc(50% + 70px);
      height: 100%;
      .top-container {
        height: 270px;
        .year-box {
          gap: 10px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          margin: 0 5px;
          height: 100%;
          width: 100%;
          color: #ffffff;
          .item-box {
            border: 1px solid #369aff;
            background: rgba(0, 186, 255, 0.1);
            display: flex;
            align-items: center;
            padding: 0 20px;
            height: 100%;
            .item-data-box {
              margin-left: 10px;
            }
          }
        }
        .mouth-box {
          gap: 10px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          margin: 0 5px;
          height: 100%;
          width: 100%;
          color: #ffffff;
          .item-box {
            border: 1px solid #369aff;
            background: rgba(0, 186, 255, 0.1);
            display: flex;
            align-items: center;
            padding: 0 20px;
            height: 100%;
            .item-data-box {
              margin-left: 10px;
            }
          }
        }
        .day-box {
          gap: 10px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          margin: 0 5px;
          height: 100%;
          width: 100%;
          color: #ffffff;
          .item-box {
            border: 1px solid #369aff;
            background: rgba(0, 186, 255, 0.1);
            display: flex;
            align-items: center;
            padding: 0 20px;
            height: 100%;
            .item-data-box {
              margin-left: 10px;
            }
          }
        }
        .previous-box {
          gap: 10px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          margin: 0 5px;
          height: 100%;
          width: 100%;
          color: #ffffff;
          .item-box {
            position: relative;
            border: 1px solid #369aff;
            background: rgba(0, 186, 255, 0.1);
            display: flex;
            align-items: center;
            padding: 0 20px;
            height: 100%;
            .item-data-box {
              margin-left: 10px;
            }
          }
        }
      }
      .bottom-container-nhqs {
        position: relative;
        margin-top: 10px;
        width: 100%;
        height: calc(100% - 280px);
        .echart-container {
          height: calc(100% - 30px);
        }
      }
    }
    .right-container {
      float: right;
      width: calc(50% - 80px);
      height: 100%;
      .top-container {
        display: flex;
        height: 270px;
        justify-content: space-around;
        gap: 10px;
        .ynzb-box {
          width: 100%;
          .pie1-box {
            height: 240px;
            border: 1px solid #369aff;
            background: rgba(0, 186, 255, 0.1);
          }
        }
        .yxqk-box {
          width: 100%;
          .qkdata-box {
            padding: 30px 20px;
            height: 240px;
            border: 1px solid #369aff;
            background: rgba(0, 186, 255, 0.1);
            display: flex;
            flex-direction: column;
            gap: 30px;
            .qkdata-box-item {
              display: flex;
              align-items: center;
              justify-content: space-between;
              .qkdata-box-item-name {
                color: #03b7e6;
                font-size: 23px;
                display: flex;
                align-items: center;
              }
              .qkdata-box-item-num {
                font-size: 20px;
                color: #ffffff;
              }
            }
          }
        }
      }
      .bottom-container-ynpm {
        position: relative;
        margin-top: 10px;
        width: 100%;
        height: calc(100% - 280px);
        .echart-container {
          height: calc(100% - 30px);
        }
      }
    }
  }
}
</style>
